import { render, staticRenderFns } from "./supplyChain.vue?vue&type=template&id=cf00fe42&scoped=true"
import script from "./supplyChain.vue?vue&type=script&lang=js"
export * from "./supplyChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf00fe42",
  null
  
)

export default component.exports